import type { NotificationDto } from "@/entities/notification/types"

/** Возвращает внутренний путь для перехода по клику на уведомление, либо null. */
export const resolveNotificationHref = (_n: NotificationDto): string | null => null
